import { Suspense, type FunctionComponent } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyPremiumTrialModalOverlays: FunctionComponent = () => {
  const PremiumTrialModalOverlays = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "premium-trial-modal-overlays" */ 'app/src/components/PremiumTrialModalOverlay/PremiumTrialModalOverlays'
      ),
    { namedImport: 'PremiumTrialModalOverlays', preload: false },
  );

  return (
    <ChunkLoadErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <PremiumTrialModalOverlays />
      </Suspense>
    </ChunkLoadErrorBoundary>
  );
};
